import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DynamicTableModule } from 'material-dynamic-table';
import { TableComponent } from './table.component';

@NgModule({
  imports: [CommonModule, DynamicTableModule, TableComponent],
  exports: [TableComponent],
})
export class TableModule {}
